import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { OutOfBoundsStrategy } from "../drag-and-drop.interface";

export class HighlightOriginStrategy implements OutOfBoundsStrategy {
    handleOutOfBounds(drag: CdkDrag<any>, originDropList?: CdkDropList<any>, activeDropList?: CdkDropList<any>): void {
        this.addOutOfBoundsStyling(drag, originDropList, activeDropList);
    }
    handleReturnInBounds(): void {
        this.removeOutOfBoundsStyling();
    }
    handleDragEnd(): void {
        this.removeOutOfBoundsStyling();
    }

    private addOutOfBoundsStyling(drag: CdkDrag<any>, originDropList?: CdkDropList<any>, activeDropList?: CdkDropList<any>) {
        if (!drag || !originDropList || !activeDropList) return;

        // If dragged element is leaving its original drop list, anchor has not been created yet, so nothing to style
        if (activeDropList !== originDropList) {
            const placeholderElement = drag.getPlaceholderElement();
            placeholderElement.classList.add("wk-drag-out-of-bounds");

            const anchorElement = document.querySelector(".cdk-drag-anchor");
            if (anchorElement) {
                anchorElement.classList.add("wk-drag-out-of-bounds");
            }
        }
    }

    private removeOutOfBoundsStyling() {
        const outOfBoundsElements = document.querySelectorAll(".wk-drag-out-of-bounds");
        outOfBoundsElements.forEach((el) => el.classList.remove("wk-drag-out-of-bounds"));
    }
}
